import { type } from 'arktype';
import { createPaginatedResponseSchema } from '../shared/pagination';

/** Contrato del catálogo `experienceSeries` (serie a la que pertenece una experiencia). */
export const experienceSeriesResponseSchema = type({
	createdAt: 'string.date.iso',
	description: 'string | null',
	id: 'string.uuid',
	name: 'string',
	updatedAt: 'string.date.iso',
}).onUndeclaredKey('delete');

export type ExperienceSeriesResponse = typeof experienceSeriesResponseSchema.infer;

export const createExperienceSeriesSchema = type({
	'description?': 'string',
	name: 'string',
}).onUndeclaredKey('delete');

export type CreateExperienceSeries = typeof createExperienceSeriesSchema.infer;

export const updateExperienceSeriesSchema = createExperienceSeriesSchema.partial();

export type UpdateExperienceSeries = typeof updateExperienceSeriesSchema.infer;

export const experienceSeriesPaginatedResponseSchema = createPaginatedResponseSchema(experienceSeriesResponseSchema);

export type ExperienceSeriesPaginatedResponse = typeof experienceSeriesPaginatedResponseSchema.infer;
